import React, { ReactNode } from "react";
import { Text } from "@chakra-ui/react";

interface Props {
  // 비활성 CTA 와 aria-describedby 로 이어 주는 id.
  id: string;
  // 이전/다음처럼 CTA 가 오른쪽에 붙는 행에서만 right.
  textAlign?: "left" | "right";
  children: ReactNode;
}

/**
 * CTA 가 막힌 이유를 알리는 문구.
 *
 * 카드·단계 설명문(#6F6F6C)과 같은 회색을 쓰면 그냥 배경 설명처럼 읽혀
 * "이걸 해야 넘어간다"가 눈에 들어오지 않는다. 배지 팔레트의 yellow(#B27700)로
 * 갈라 둔다 — 실패가 아니라 선행 조건 안내이므로 red 는 쓰지 않는다.
 */
function PathPickStartGuideDisabledHint({ id, textAlign, children }: Props) {
  return (
    <Text
      id={id}
      textStyle={"caption-bold"}
      color={"#B27700"}
      textAlign={textAlign}
    >
      {children}
    </Text>
  );
}

export default PathPickStartGuideDisabledHint;
